import { checkISO8601Format, formatDateToDDMMYY } from "../utils/format-time";
import plusIcon from "../assets/img/icon-plus.png";

const getCellValue = (obj, header) => {
  if (!obj || !header) return "";
  const raw =
    (header.parent ? obj?.[header.parent]?.[header.key] : obj?.[header.key]) ??
    "";
  if (header.render) return header.render(raw, obj); // custom render hook

  if (checkISO8601Format(raw)) {
    try {
      return formatDateToDDMMYY(new Date(raw));
    } catch {
      return raw;
    }
  }
  return raw;
};

const StockDetailPopup = ({
  detailData = {},
  loading = false,
  detailPopupTitle = "Stock Import Information",
  detailPopupHeaders = [],
  onCloseClick = () => {},
  detailPopupTableHeaders = [],
  detailPopupTableTitle = "Product Details",
  detailPopupTableKey = "importDetails",
}) => {
  const detailRows = Array.isArray(detailData?.[detailPopupTableKey])
    ? detailData[detailPopupTableKey]
    : [];

  return (
    <div className="popup">
      <div className="flex flex-row-reverse">
        <button onClick={onCloseClick}>
          <img src={plusIcon} alt="close icon" className="rotate-45 w-5 h-5" />
        </button>
      </div>

      <div className="px-8">
        {/* Title */}
        <div className="flex pb-4">
          <h1 className="text-3xl">{detailPopupTitle}</h1>
        </div>

        {loading ? (
          <div className="py-8 text-center text-lg">Loading details...</div>
        ) : (
          <>

            {/* Header info table */}
            <div>
              <table className="list-detail-table">
                <tbody>
                  {detailPopupHeaders.map((header, index) => {
                    let value = header.parent
                      ? detailData?.[header.parent]?.[header.key]
                      : detailData?.[header.key];

                    // Arrays shown as vertical list (rare for header section)
                    if (Array.isArray(value)) {
                      return (
                        <tr key={index}>
                          <td className="align-baseline">{header.name}</td>
                          <td className="px-8 align-baseline">:</td>
                          <td className="align-baseline">
                            {value.map((item, i) => (
                              <div key={i}>
                                {item?.product?.product_name
                                  ? `${item.product.product_name} x ${item.quantity}`
                                  : JSON.stringify(item)}
                              </div>
                            ))}
                          </td>
                        </tr>
                      );
                    }

                    return (
                      <tr key={index}>
                        <td>{header.name}</td>
                        <td className="px-8">:</td>
                        <td>{getCellValue(detailData, header) || "-"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Details table */}
            {detailPopupTableHeaders?.length > 0 && (
              <>
                <div className="x-divider my-4"></div>

                <div>
                  <div className="flex pb-4">
                    <h1 className="text-2xl">{detailPopupTableTitle}</h1>
                  </div>

                  <div>
                    <table className="list-detail-table-type-2">
                      <thead>
                        <tr>
                          {detailPopupTableHeaders.map((h, i) => (
                            <th key={i}>{h.name}</th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {detailRows.map((row, ri) => (
                          <tr key={ri}>
                            {detailPopupTableHeaders.map((h, hi) => {
                              const raw = h.parent
                                ? row?.[h.parent]?.[h.key]
                                : row?.[h.key];

                              const cell =
                                h.render?.(raw, row) ??
                                (checkISO8601Format(raw)
                                  ? formatDateToDDMMYY(new Date(raw))
                                  : raw ?? "-");

                              const color =
                                h.key === "status"
                                  ? row[h.key] === "ACTIVE"
                                    ? "#149D52"
                                    : row[h.key] === "Cancelled"
                                    ? "#FF0000"
                                    : "#0870D8"
                                  : undefined;

                              return (
                                <td key={hi} style={{ color }}>
                                  {cell}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default StockDetailPopup;
